import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';

import { ButtonGroup, Button } from '../buttonpanel';

import css from '../../styles/filter/periodfilter';

class PeriodFilter extends Component {
    static propTypes = {
        // Props
        changeFilters: PropTypes.func.isRequired,
        period: PropTypes.string.isRequired,
        tabs: PropTypes.array,
        t: PropTypes.func.isRequired,
    };

    constructor(props) {
        super(props);

        const t = this.props.t;

        if (props.tabs) {
            this.tabs = props.tabs;
        } else {
            this.tabs = [
                [t('day'), 'DAY'],
                [t('week'), '7DAYS'],
                [t('month'), 'MONTH'],
                [t('year'), '1YEAR'],
                [t('yearWithCount', { count: 3 }), '3YEARS'],
                [t('yearWithCount', { count: 5 }), '5YEARS'],
            ];
        }

        this._getType = (period) => {
            if (this.props.period === period) {
                return 'tab';
            }

            return 'transparent';
        };

        this._periodFilterClick = (tabIndex) => {
            this.props.changeFilters({ period: this.tabs[tabIndex][1] });
        };
    }

    render() {
        return (
            <ButtonGroup direction="inline" className={css.buttonGroup}>
                {this.tabs.map((tab, index) => (
                    <Button
                        onClick={() => this._periodFilterClick(index)}
                        key={tab[1]}
                        label={tab[0]}
                        type={this._getType(tab[1])}
                    />
                ))}
            </ButtonGroup>
        );
    }
}

export default translate('date')(PeriodFilter);



/** WEBPACK FOOTER **
 ** /src/shared/components/filter/PeriodFilter.js
 **/